import { useAuth } from '@frontegg/react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function SignIn() {
  // const loginWithRedirect = useLoginWithRedirect();
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && isAuthenticated) {
      navigate('/fleet-manager');
    }
  }, [user, isAuthenticated, navigate]);

  // const logout = () => {
  //   const baseUrl = ContextHolder.getContext().baseUrl;
  //   window.location.href = `${baseUrl}/oauth/logout?post_logout_redirect_uri=${window.location}`;
  // };

  // const handleShowAdmin = () => {
  //   AdminPortal.show();
  // };

  return <div></div>;
  // <div className="h-full w-full flex flex-col justify-center items-center">
  //   <button
  //     className="mx-auto p-[12px] bg-primary-500 rounded-[8px] text-white"
  //     onClick={() => loginWithRedirect()}
  //   >
  //     Login to datafy
  //   </button>
  // </div>
}

export default SignIn;
